<template>
  <div
    class="informationTableContainer"
    :class="className"
    v-if="source && source.length"
  >
    <div class="is-hidden-print-view">
      <h2 class="Heading">{{ title }}</h2>
      <table class="informationTable">
        <template v-if="type === 'image'">
          <tr>
            <td>
              <div class="Images">
                <div class="Image" v-for="(item, index) in source" :key="index">
                  <el-image :src="item"> </el-image>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(item, index) in source" :key="index">
            <td class="Text" v-if="item[1][0]">
              <template v-if="isString(item[1])">
                {{ item[1] }}
              </template>
              <template v-if="isImage(item[1])">
                <ImageResolver :src="item[1].src" />
              </template>
              <template v-if="isImageList(item[1])">
                <ImageResolver
                  v-for="(o, index) in item[1]"
                  :key="index"
                  :src="o.src"
                />
              </template>
              <!-- comment -->
              <template v-if="item[2] && item[2].type == 'comment'">
                <div class="comment">{{ item[2].value }}</div>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </div>

    <hr class="print-view" />

    <!-- 改行の要件に対応するために、印刷用の表示を作る -->
    <div class="print-view">
      <div
        class="PrintView-Section"
        v-for="(item, index) in source"
        :key="index"
      >
        <span class="PrintView-Heading">{{ item[0] }}</span>
        <span class="Text">
          <template v-if="isString(item[1])">
            {{ item[1] }}
          </template>
          <template v-if="isImage(item[1])">
            <ImageResolver :src="item[1].src" />
          </template>
          <template v-if="isImageList(item[1])">
            <ImageResolver
              class="PrintView-Image"
              v-for="(o, index) in item[1]"
              :key="index"
              :src="o.src"
              :size="200"
            />
          </template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => "",
    },
    source: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "text",
    },
    className: {
      type: String,
      default: () => "",
    },
  },
  components: {},
  methods: {
    isString (val) {
      return typeof val === "string";
    },
    isImage (val) {
      return (
        typeof val === "object" &&
        val !== null &&
        !Array.isArray(val) &&
        val.src
      );
    },
    isImageList (val) {
      return Array.isArray(val) && val.length && val[0].src;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.Heading {
  font-size: 18px;
  color: $--color-primary;
  margin-bottom: 5px;
}
.Text {
  font-size: 18px;
}
.InformationTableContainer {
  width: 80%;
  margin: auto;
}
.informationTable {
  width: 100%;
  border-top: 1px solid $--border-color-lighter;
  table-layout: fixed;
}
.informationTable th {
  width: 60px;
  padding: 5px;
}
.informationTable th,
.informationTable td {
  white-space: pre-wrap;
  text-align: left;
  border-bottom: 1px solid $--border-color-lighter;
}
.informationTable td {
  width: 50%;
}
.Images {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  grid-gap: 5px;
}
.Image {
  width: 100%;
}
.Image > * {
  max-width: 100%;
}
.Image:before {
  content: "";
  padding-bottom: 100%;
  display: inline-block;
  vertical-align: top;
}
.comment {
  margin-bottom: 5px;
}

hr {
  page-break-after: always !important;
}
.PrintView-Section:nth-child(2n) {
  page-break-after: always !important;
}
.PrintView-Section {
  display: flex;
  /* border-bottom: 1px solid $--border-color-lighter; */
  height: 50vh;
}
.PrintView-Heading {
  font-size: 50px;
  font-weight: bold;
  margin-right: 100px;
}
.PrintView-Image {
  margin-right: 50px;
}

.print-view {
  display: none;
}
@media print {
  .print-view {
    display: block;
    margin: 15mm 10mm 15mm 10mm;
  }
  .is-hidden-print-view {
    display: none;
  }
}
</style>
